import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";

const initialState: any = {
  cardData: [],
  status: "pending"
};

export const getCardsList = createAsyncThunk<any>(
  "getCardsList/setCardsList",
  async (_, thunkAPI) => {
    try {
      const response = await ApiClient("payment/cards-list?limit=1000");
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getCardsListSlice = createSlice({
  name: "getCardsList",
  initialState,
  reducers: {
    setCardsList(state, action) {
      state.cardData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getCardsList.pending,(state) => {
          state.status = "";
      });
    builder.addCase(getCardsList.fulfilled, (state, action: PayloadAction<any>) => {
      state.cardData = action.payload;
      state.status = "succeeded"
    });
    builder.addCase(
      getCardsList.rejected,(state) => {
          state.status = "failed";
      });
  },
});

export const { setCardsList } = getCardsListSlice.actions;
export default getCardsListSlice;
